import React from 'react'
import styles from './tag.module.scss'
import { Icon, type IconProps } from '../Icon/Icon'

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Props extends a DOM attributes interface; interface extension is idiomatic here
export interface TagProps extends React.HTMLAttributes<HTMLElement> {
  icon?: IconProps
  label: React.ReactNode
  bgColor?: 'corn' | 'light-corn' | 'kale' | 'mint' | 'light-grana' | 'light-olive' | 'olive' | 'grana' | 'white' | 'cream' | 'light-cream'
  borderRadius?: 'l' | 's'
  showArrow?: boolean
}

export const Tag: React.FC<TagProps> = ({
  icon,
  label,
  bgColor = 'light-olive',
  borderRadius = 'l',
  showArrow = false,
  className,
  ...props
}) => {
  const classes = [
    className ?? '',
    styles.tag,
    'modul',
    'flx-a-c',
    `bg-${bgColor}`,
    borderRadius === 's' ? styles['tag--radius-s'] : '',
    !icon ? styles['tag--no-icon'] : '',
  ].filter(Boolean).join(' ')

  const textColorClass =
    bgColor === 'kale' || bgColor === 'olive' || bgColor === 'grana'
      ? 'txt-white'
      : ''

  return (
    <div className={classes} {...props}>
      {showArrow && <span className={`${styles['tag__arrow']} bg-${bgColor}`} />}
      {icon != null && <Icon {...icon} />}
      <div className={['txt-p-2', 'txt-p-2-s', textColorClass].filter(Boolean).join(' ')}>
        {typeof label === 'string' ? <span>{label}</span> : label}
      </div>
    </div>
  )
}
